module.exports = __webpack_public_path__ + "img/face66.a0e172d3.gif";